module.exports = __webpack_public_path__ + "c7c61f180847fe64b7ff85de0400a9ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./2017-04-08-harrison-yoga/snippet.jpg
// module id = 609
// module chunks = 0